import React, { useState, useEffect } from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import TpRunService from '../../../../Services/TpRunService';
import stringHelper from '../../../../Helpers/stringHelper';
import ErrorMessage from '../../../ErrorMessage';

/**
 * TpRunSelect — dropdown of TpRuns for the client owning a pricing.
 * Used to pick the Run when extending a TP-platform planning detail.
 *
 * Props:
 *   value         — selected TpRunId
 *   onChange      — change handler passed to SelectFieldCheckbox
 *   idFilter      — pricingId whose client's runs are listed
 *   fieldName     — field name for SelectFieldCheckbox
 *   className     — input class
 *   filterCleared — clears the selection
 */
const TpRunSelect = ({
  value = null,
  className = 'w-100 form-control form-control-sm',
  filterCleared = false,
  fieldName = 'defaultFieldname',
  onChange = () => {},
  idFilter = null,
}) => {
  const [selectValues, setSelectValues] = useState([]);

  useEffect(() => {
    if (!idFilter) {
      setSelectValues([]);
      return;
    }

    TpRunService.ListByPricing(idFilter)
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result
          .sort((a, b) => (a.thirdPartyName > b.thirdPartyName ? 1 : -1))
          .forEach((tpRun) => {
            optValues.push({
              label: tpRun.thirdPartyName + stringHelper.toBracket(tpRun.thirdPartyRunId),
              value: tpRun.tpRunId,
              disabled: false,
            });
          });
        setSelectValues(optValues);
      })
      .catch(() => {
        setSelectValues([]);
        ErrorMessage.SetErrorMessage('TRS57');
      });
  }, [idFilter]);

  return (
    <SelectFieldCheckbox
      value={value}
      className={className}
      fieldName={fieldName}
      onChange={onChange}
      filterCleared={filterCleared}
      selectValues={selectValues}
    />
  );
};

export default TpRunSelect;
